export const isDecimal = (number: number): boolean => number.toString().indexOf('.') !== -1;
